export enum CampaignAudienceTypeEnum {
  ALL_LEADS = 'ALL_LEADS',
  TAGS = 'TAGS',
  CONTACT_GROUP = 'CONTACT_GROUP',
  FILE = 'FILE',
}

export enum CampaignAudienceSourceEnum {
  BASE = 'BASE',
  FILE_NEW = 'FILE_NEW',
  FILE_EXISTING = 'FILE_EXISTING',
}

export enum CampaignStatusEnum {
  WAITING = 'WAITING',
  SENDING = 'SENDING',
  DONE = 'DONE',
  CANCELED = 'CANCELED',
  ERROR = 'ERROR',
}

export enum CampaignExecutionTypeEnum {
  IMEDIATE = 'IMEDIATE',
  SCHEDULED = 'SCHEDULED',
}

export enum CampaignMessageStatusEnum {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  EXCEPTION = 'EXCEPTION',
}
